import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary';
import { initSentry } from './lib/sentry';
import './index.css';

// Story 8.1 Task 1.4/1.5: Initialize Sentry before React render
initSentry();

/**
 * Story 7.3: Skeleton-to-App Crossfade
 * Smoothly transitions from HTML skeleton to React app
 */
function handleSkeletonCrossfade(): void {
  const skeleton = document.getElementById('initial-skeleton');
  const root = document.getElementById('root');

  // Story 7.3 Task 3: Clear slow network indicator timer
  if (typeof (window as Window & { __clearSlowTimer?: () => void }).__clearSlowTimer === 'function') {
    (window as Window & { __clearSlowTimer?: () => void }).__clearSlowTimer!();
  }

  if (skeleton && root) {
    // Start fade out skeleton, fade in app
    skeleton.classList.add('fade-out');
    root.classList.add('app-ready');

    // Remove skeleton from DOM after transition completes (300ms)
    setTimeout(() => {
      skeleton.classList.add('hidden');
    }, 300);
  }
}

// Create root and render
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </ErrorBoundary>
    </StrictMode>
  );

  // Story 7.3: Trigger crossfade after React renders
  // Use requestAnimationFrame to ensure React has painted
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      handleSkeletonCrossfade();
    });
  });
}